import { render, staticRenderFns } from "./IconAccommodation.vue?vue&type=template&id=3ecc6b98&"
import script from "./IconAccommodation.vue?vue&type=script&lang=js&"
export * from "./IconAccommodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports